import React from 'react';
import { CtaBlock } from '../CtaButton';
import { Accent } from './SectionHeading';
import { AssuranceRow } from './AssuranceRow';
import { MOCKUP_URL } from '../../data/images';
export function HeroSection() {
  return <section className="bg-brand-paper px-5 pb-16 pt-10 lg:px-8 lg:pb-20 lg:pt-14" data-id="element-102" data-mp="16okwuzd879zg">
      <div className="mx-auto max-w-4xl text-center" data-id="element-103" data-mp="12mr37b1g768s">
        <p className="inline-flex items-center rounded-[8px] border border-brand-gold/40 bg-brand-ivory px-4 py-2 font-body text-[10px] font-bold uppercase tracking-[0.18em] text-brand-charcoal/75 sm:text-[11px]" data-id="element-104" data-mp="12k4uv96qgmpi">
          Pour les formatrices et formateurs en coiffure
        </p>

        <h1 className="mt-6 font-display text-[2.6rem] font-bold leading-[1.02] tracking-[-0.015em] text-brand-charcoal sm:text-[3.4rem] lg:text-[4.25rem]" data-id="element-105" data-mp="1q9phq360c442">
          Préparez vos cours de coiffure en <Accent data-id="element-106" data-mp="exyb5pny5ijg">quelques minutes</Accent>, pas en plusieurs heures.
        </h1>

        <p className="mx-auto mt-6 max-w-2xl text-[15px] leading-relaxed text-brand-charcoal/70 sm:text-[16px]" data-id="element-107" data-mp="9whfq9o8eoa9">
          Un système prêt à enseigner pour expliquer les techniques, faire pratiquer et évaluer vos élèves.
        </p>
      </div>

      <img src={MOCKUP_URL} alt="Hair Instructor Ready — Édition Française : les 6 volumes et des pages intérieures sur tablette, ordinateur et téléphone" width={1536} height={1024} loading="eager" decoding="async" className="mx-auto mt-10 block w-full max-w-[600px] object-contain lg:max-w-[900px]" style={{
      filter: 'drop-shadow(0 34px 40px rgba(120, 96, 56, 0.22))'
    }} data-id="element-108" data-mp="3dd1tx4d39rm4" />

      <p className="mx-auto mt-8 max-w-2xl text-center text-[15px] leading-relaxed text-brand-charcoal/75 sm:text-[16px]" data-id="element-109" data-mp="2gq6qc9i89sv9">
        Fini les heures passées à créer vos cours de zéro ! Découvrez{' '}
        <strong className="font-semibold text-brand-charcoal" data-id="element-110" data-mp="26s0o1qsiekpv">Hair Instructor Ready™</strong>, un système
        pédagogique complet avec des ressources pour expliquer les techniques, organiser les exercices et
        évaluer vos élèves.
      </p>

      <p className="mt-5 text-center font-body text-[12px] font-bold uppercase tracking-[0.16em] text-brand-gold" data-id="element-111" data-mp="hbooxm4vxbgx">
        6 volumes + 5 bonus · Édition française
      </p>

      <CtaBlock label="Je veux préparer mes cours plus vite" className="mt-7" data-id="element-112" data-mp="8i1y8afjayel" />
      <AssuranceRow className="mt-5" data-id="element-113" data-mp="3jib46p7fgkn" />
    </section>;
}